import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidUkIcon,
  IphoneUkIcon,
  GameUkIcon,
  FlutterIcon,
  HealthcareUkIcon,
  ReactUkIcon,
} from "../../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidUkIcon,
    title: "iOS Development Consulting",
    description:
      "Our iOS app development service begins with a thorough consultation, involving expert teams and stakeholders. We provide a detailed roadmap, covering the development framework, cost estimation, process overview, and recommended tech stack. Under our guidance, gain a clear understanding of the development journey ahead.",
  },
  {
    icon: IphoneUkIcon,
    title: "Custom IOS App Development",
    description:
      "TekRevol's dedicated iPhone app development team transforms your ideas into reality. Following agile methodologies and embracing a DevOps culture, we seamlessly turn wireframes and designs into fully functional iOS apps. Our meticulous attention to detail and commitment to quality ensures high-performance, feature-rich applications that exceed your expectations.",
  },
  {
    icon: GameUkIcon,
    title: "UI and UX Design for iPhone",
    description:
      "Prioritizing user experience and interface superiority, our iOS app development process emphasizes creating precise wireframes and prototypes for a robust interface foundation. Combining aesthetics with functionality, we ensure captivating UI/UX designs that can elevate the overall app experience.",
  },
  {
    icon: FlutterIcon,
    title: "iOS Web App Development",
    description: (
      <>
        "Explore seamless iOS web app development with our skilled team.
        Crafting responsive and user-friendly web applications tailored for the
        iOS platform, we deliver state-of-the-art designs and robust
        functionality. Our solutions ensure an optimized user experience,
        enhancing your online presence through cutting-edge iOS web app
        development services. Partner with us to elevate your digital presence
        through our specialized iOS web app development and holistic{" "}
        <Link to="https://www.tekrevol.com/uk/web-development-company-uk">
          web development services.
        </Link>
        "
      </>
    ),
  },
  {
    icon: HealthcareUkIcon,
    title: "iOS App Testing",
    description:
      "Ensure a smooth iOS app launch with our comprehensive testing and deployment services. Rigorous automated tests identify and resolve potential issues, ensuring flawless functionality. Our meticulous approach ensures a secure backend and impeccable user experience, guaranteeing a trouble-free submission and deployment on the App Store.",
  },
  {
    icon: ReactUkIcon,
    title: "App Support and Maintenance with New Features",
    description:
      "Boost your app's endurance and performance with our comprehensive support and maintenance services. Our expert team ensures your application remains updated, secure, and efficient. From routine maintenance to adding new features, we keep your app at the forefront of innovation. Partner with us for sustained excellence.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              TekRevol’s Game-Changing iOS App Development Services in London
            </h2>
            <p className="impro_para">
              Experience the game-changing impact of TekRevol's iPhone app
              development services. As your trusted iOS app development agency
              in London, we deliver effective iOS solutions tailored to meet
              your business needs. Here are the iOS app development services in
              London that TekRevol offers:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
